<template>
  <div class="fluid page_content self_reported_courses">
    <div class="row page-heading mx-0" v-if="!isLoadingOnWidget">
      <div class="col-8 input module_heading" role="heading" aria-level="1" style="padding-left: 5px;">
        <span class="user-profile">
          <span class="user-profile-icon" v-html="username.charAt(0).toUpperCase()"></span>
        </span>
        <span class="module_type_name" style="padding: 6px 5px 0 3px !important;"><strong>My Profile > Completed Courses</strong></span>
      </div>
      <div class="col-4 submit btn-container text-right">
        <b-button @click="backToExplore" aria-label="back to explore">Back To Explore</b-button>
      </div>
    </div>

    <div class="courses_section" v-if="isCoursesLoaded">
      <template v-if="((Object.keys(selfReportedCourseMap).length > 0) && !$parent.isGuestLogin)">
        <div class="row course_list_head">
          <div class="filter" :class="isLoadingOnWidget ? 'col-4' : 'col-8'">
            <div class="search_field ml-1">
              <input v-model="searchTitle" v-on:keyup="keyupEvent" placeholder="filter by course name" aria-label="filter by course title" style="float: left;" :style="{height: isLoadingOnWidget ? '25px' : '24px', width: isLoadingOnWidget ? '90%' : '30%'}">
              <div class="clear-btn" v-if="searchTitle.length > 0">
                <b-button @click="resetPage" aria-label="clear">X</b-button>
              </div>
            </div>
          </div>
          <div class="info" :class="isLoadingOnWidget ? 'col-8' : 'col-4'">
            <div class="float-left" v-if="totalElements">
              <span>Courses: <b>{{totalElements}}</b></span>
            </div>
            <div class="float-right" style="margin-right: 1.5rem;">
              <span class="ic9-iconPiggy-0002"></span>
              <span v-if="countInfo" class="mr-3">
                <span><b>{{countInfo.credit}}</b> credits across <b>{{countInfo.programCount}}</b> programs</span>
              </span>
              <span class="submit btn-container text-right">
                <template v-if="isLoadingOnWidget">
                  <b-button @click="addCourseFromWidget" aria-label="add">add</b-button>
                </template>
                <template v-else>
                  <b-button @click="addCourse" aria-label="add">add</b-button>
                </template>
              </span>
            </div>
          </div>
        </div>
      </template>

      <template v-if="((Object.keys(selfReportedCourseMap).length > 0) && !$parent.isGuestLogin)">
        <div class="inst_list_container">
          <template v-for="(courses, label, i) in selfReportedCourseMap">
            <div v-if="courses.length > 0">
              <div class="row" role="heading" tabindex="0" :style="{background: isLoadingOnWidget ? '#f5f5f5' : '#eaf8ff'}">
                <div class="col-12 inst_head">
                  <div class="institution-head-title-circle float-left" v-b-toggle="'institution-' + i" @click.prevent="toggleExpandCollapse(i)" style="cursor: pointer;">
                    <span :id="'inst-head-exp-coll-' + i">-</span>
                  </div>
                  <div class="row title">
                    <div class="title_txt" :class="isLoadingOnWidget ? 'col-9' : 'col-9'">{{label}}</div>
                    <div class="course_count" :class="isLoadingOnWidget ? 'col-3' : 'col-3'">
                      <template v-if="courses.length > 1">{{courses.length}} Courses</template>
                      <template v-else>{{courses.length}} Course</template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <b-collapse visible :id="'institution-' + i">
                    <div class="course_list_container">
                      <template v-for="course in courses">
                        <div class="row course_row">
                          <div class="title col-6">
                            <div :class="!isLoadingOnWidget ? 'ml-4' : 'ml-0'">
                              <div class="float-left text-center mr-3" style="width: 80px;">
                                <div style="height: 50px; border-radius: 8px;" :style="{background: setThumbnailBgColor(course.uuid)}">
                                  <div style="line-height: 50px; color: #fff;">
                                    <div v-html="setThumbnailTitle(course)"></div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div class="col_title" style="cursor: default !important; color: #5f5f5f !important;">
                                  {{course.title}}
                                </div>
                                <div class="small-desc">
                                  {{course.credits}} credits
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="txt_container">
                              <span>
                                {{course.term}}, {{course.year}}
                              </span>
                              <span class="grade">Grade: {{getGradeText(course.gradeEarned)}}</span>
                            </div>
                            <div class="small-desc">
                              <span class="ic9-iconPiggy-0002"></span>
                              {{course.credits}} credits across {{course.programCount}} programs
                            </div>
                          </div>
                          <div class="col-2 text-center">
                            <div class="float-right mr-4">
                              <span class="action-link ico-edit mr-2" aria-label="edit" tabindex="0" style="cursor: pointer; color: #157099;" @click="editCourse(course.uuid)"></span>
                              <span class="action-link icon-bin2" aria-label="delete" tabindex="0" style="cursor: pointer; color: #157099;" @click="selectForDelete(course.uuid)"></span>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </b-collapse>
                </div>
              </div>

            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="inst_list_container" :class="{row: !isLoadingOnWidget}">
          <template v-if="isLoadingOnWidget">
            <div class="col-12">
              <b-card bg-variant="light-gray" class="text-center">
                <div class="mt-5">
                  <template v-if="$parent.isGuestLogin">
                    <b-card-text>Login to view your added courses</b-card-text>
                  </template>
                  <template v-else>
                    <b-card-text>No courses have been added</b-card-text>
                  </template>
                </div>
                <div class="mt-4 mb-5">
                  <b-card-text>
                    <template v-if="$parent.isGuestLogin">
                      <b-button @click="loginToAdd" aria-label="add">login</b-button>
                    </template>
                    <template v-else>
                      <b-button @click="addCourseFromWidget" aria-label="add">add</b-button>
                    </template>
                  </b-card-text>
                </div>
              </b-card>
            </div>
          </template>
          <template v-else>
            <div class="col-3"></div>
            <div class="col-6">
              <b-card bg-variant="light-gray" class="text-center">
                <div class="mt-5">
                  <b-card-text>No courses have been added</b-card-text>
                </div>
                <div class="mt-4 mb-5">
                  <b-card-text><b-button @click="addCourse" aria-label="add">add</b-button></b-card-text>
                </div>
              </b-card>
            </div>
            <div class="col-3"></div>
          </template>
        </div>
      </template>
    </div>

    <div>
      <b-modal id="delete-completed-course-popup" ref="deleteConfirmModal" :header-bg-variant="'delete-course-popup-header'" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt">
            <span>Please Confirm!</span>
          </div>
          <div class="btn_container">
            <button class="btn_close" aria-label="close" @click="cancelDelete">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div style="text-align: center;">
          <h6>Are you sure you want delete?</h6>
        </div>
				<div slot="modal-footer" class="w-100">
          <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal id="add-completed-course-popup" ref="addCourseModal" size="xl" hide-header hide-footer no-close-on-backdrop no-close-on-esc centered>
        <div class="hd">
          <span class="hd_txt">{{addCourseModel.addEditCourseHeader}}</span>
          <b-button class="btn_close" @click="cancel" aria-label="cancel">
            <span class="ic-close"></span>
          </b-button>
        </div>

        <div class="fld_container">

          <div class="counts_info">
            <template v-if="countInfo">
              <span class="ic9-iconPiggy-0002"></span>
              <span class="counts"><b>{{countInfo.credit}}</b> credits across <b>{{countInfo.programCount}}</b> programs</span>
            </template>
          </div>

          <div class="row" style="max-width: 70%; margin: auto;">

            <div class="col-12">

              <div class="row fld_row">
                <div class="col-12 fld_label">Institution <sup>*</sup></div>
                <div class="col-12 fld_input">
                  <v-select class="select-field" v-model="addCourseModel.sourceInstitution" :clearable="false"
                    :options="addCourseModel.sourceInstitutions" label="title" placeholder="Select Any Institution" :disabled="addCourseModel.uuid"></v-select>
                </div>
              </div>
              <div class="row fld_row">
                <div class="col-12 fld_label">Course Name <sup>*</sup></div>
                <div class="col-12 fld_input">
                  <v-select class="select-field" v-model="addCourseModel.sourceCatalog" :clearable="false"
                    :options="addCourseModel.sourceCatalogs" label="title" placeholder="Select Any Course" :disabled="(addCourseModel.uuid || !addCourseModel.sourceInstitution)"></v-select>
                </div>
              </div>
              <div class="row fld_row">
                <div class="col-12 fld_label">Grade <sup>*</sup></div>
                <div class="col-12 fld_input">
                  <v-select class="select-field" v-model="addCourseModel.grade" :clearable="false"
                    :options="grades" label="text" placeholder="Select Any Grade"></v-select>
                </div>
              </div>
              <div class="row fld_row">
                <div class="col-12 fld_label">Category</div>
                <div class="col-12 fld_input">
                  <v-select class="select-field" v-model="addCourseModel.sourceCategory" :clearable="false"
                    :options="categories" placeholder="Select Any Category"></v-select>
                </div>
              </div>
              <div class="row fld_row">

                <div class="col-6">
                  <div class="row">
                    <div class="col-12 fld_label">Year <sup>*</sup></div>
                    <div class="col-12 fld_input">
                      <select class="form-control" v-model="addCourseModel.year">
                        <option value="" disabled selected hidden>Select Any Year</option>
                        <option v-for="option in years" v-bind:value="option" >{{option}}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="row">
                    <div class="col-12 fld_label">Term <sup>*</sup></div>
                    <div class="col-12 fld_input">
                      <select class="form-control" v-model="addCourseModel.term">
                        <option value="" disabled selected hidden>Select Any Term</option>
                        <option v-for="option in terms" v-bind:value="option" >{{option}}</option>
                      </select>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row fld_row">

                <div class="col-6">
                </div>

                <div class="col-6">
                  <div class="submit btn_container text-right">
                    <b-button @click="save" aria-label="add course" :disabled="$v.$invalid">{{addCourseModel.addEditCourseButton}}</b-button>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>

      </b-modal>
    </div>

    <!-- AddCoursePopup for widget only -->
    <div>
      <b-popover container="widgetPopover" target="widgetPopupTarget" triggers="click" :show.sync="$parent.showAddCoursePopover" :placement="'left'" style="max-width: 700px !important;">
        <div class="row" style="background: #eaf8ff; height: 50px;">
          <div class="col-12" style="margin-top: 0.5rem;">
            <div class="popup-header">
              <div class="close_btn_container" style="right: 32px;">
                <button class="btn_close" aria-label="close" @click="closeAddCourseFromWidget">
                  <span class="ic-close"></span>
                </button>
              </div>
              <div class="popup_hd">
                <span>Add Completed Courses to Save Time and Money</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mb-3 mt-3">
          <span v-if="countInfo">
            <span><b>{{countInfo.credit}}</b> credits across <b>{{countInfo.programCount}}</b> programs</span>
          </span>
        </div>
        <div class="row fld_row">
          <div class="col-12 fld_label">Institution <sup>*</sup></div>
          <div class="col-12 fld_input">
            <v-select class="select-field" v-model="addCourseModel.sourceInstitution" :clearable="false"
              :options="addCourseModel.sourceInstitutions" label="title" placeholder="Select Any Institution" :disabled="addCourseModel.uuid"></v-select>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-12 fld_label">Course Name <sup>*</sup></div>
          <div class="col-12 fld_input">
            <v-select class="select-field" v-model="addCourseModel.sourceCatalog" :clearable="false"
              :options="addCourseModel.sourceCatalogs" label="title" placeholder="Select Any Course" :disabled="(addCourseModel.uuid || !addCourseModel.sourceInstitution)"></v-select>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-12 fld_label">Grade <sup>*</sup></div>
          <div class="col-12 fld_input">
            <v-select class="select-field" v-model="addCourseModel.grade" :clearable="false"
              :options="grades" label="text" placeholder="Select Any Grade"></v-select>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-12 fld_label">Category</div>
          <div class="col-12 fld_input">
            <v-select class="select-field" v-model="addCourseModel.sourceCategory" :clearable="false"
              :options="categories" placeholder="Select Any Category"></v-select>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-6">
            <div class="row">
              <div class="col-12 fld_label">Year <sup>*</sup></div>
              <div class="col-12 fld_input">
                <select class="form-control" v-model="addCourseModel.year" style="width: 86%; height: 25px !important;">
                  <option value="" disabled selected hidden>Select Any Year</option>
                  <option v-for="option in years" v-bind:value="option" >{{option}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-12 fld_label">Term <sup>*</sup></div>
              <div class="col-12 fld_input">
                <select class="form-control" v-model="addCourseModel.term" style="width: 86%; height: 25px !important;">
                  <option value="" disabled selected hidden>Select Any Term</option>
                  <option v-for="option in terms" v-bind:value="option" >{{option}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row fld_row">
          <div class="col-6">

          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-12 submit btn-container text-right">
                <b-button @click="save" aria-label="add course" :disabled="$v.$invalid">{{addCourseModel.addEditCourseButton}}</b-button>
              </div>
            </div>
          </div>
        </div>

      </b-popover>
    </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  import _ from 'lodash'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  let initAddCourseModel = () => {
    return {
      uuid: null,
      sourceCatalog: '',
      sourceCatalogs: [],
      sourceInstitution: '',
      sourceInstitutions: [],
      sourceCategory: '',
      grade: '',
      year: '',
      term: '',
      addEditCourseHeader: 'Add Completed Course to Save Time and Money',
      addEditCourseButton: 'add course'
    }
  }

  export default {
    name: 'self-reported-course-list',
    props: ['isLoadingOnWidget'],
    data () {
      return {
        selected: [],
        searchTitle: '',
        countInfo: null,
        totalElements: 0,
        selfReportedCourseMap: {},
        addCourseModel: initAddCourseModel(),
        categories: ['CORE', 'GENED', 'ELECTIVE'],
        grades: [{text: 'A++', value: 'A++'}, {text: 'A+', value: 'A+'}, {text: 'A', value: 'A'}, {text: 'A-', value: 'A-'}, {text: 'A--', value: 'A--'}, {text: 'B++', value: 'B++'}, {text: 'B+', value: 'B+'}, {text: 'B', value: 'B'}, {text: 'B-', value: 'B-'}, {text: 'B--', value: 'B--'}, {text: 'C++', value: 'C++'}, {text: 'C+', value: 'C+'}, {text: 'C', value: 'C'}, {text: 'C-', value: 'C-'}, {text: 'C--', value: 'C--'}, {text: 'D++', value: 'D++'}, {text: 'D+', value: 'D+'}, {text: 'D', value: 'D'}, {text: 'D-', value: 'D-'}, {text: 'D--', value: 'D--'}, {text: 'Pass', value: 'P'}, {text: 'N/A', value: '-'}],
        terms: ['Spring', 'Summer', 'Fall', 'Winter'],
        userId: localStore.getItem('userid'),
        username: localStore.getItem('userFullName'),
        isCoursesLoaded: false
      }
    },
    validations () {
      return {
        addCourseModel: {
          sourceInstitution: {
            required
          },
          sourceCatalog: {
            required
          },
          grade: {
            required
          },
          year: {
            required
          },
          term: {
            required
          }
        }
      }
    },
    created () {
      this.loadPartnerInstitutions(true)
    },
    beforeMount () {
      this.populateTermsGradesAndCategories()
    },
    mounted () {
      this.showLoader()
      setTimeout(() => {
        this.loadCourseList()
      }, 500)
    },
    methods: {
      ...mapActions([
        'loadPartnerInstitutions',
        'loadSelfReportedProgramCountInfo',
        'loadSelfReportedCourseList',
        'deleteSelfReportedCourses',
        'loadSelfReportedCourse',
        'loadAddSelfReportedCourse',
        'loadCatalogsForInstitution',
        'loadTermsGradesAndCategoriesFromInstitution'
      ]),
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      getGradeText (value) {
        let item = _.find(this.grades, (grade) => {
          return (value === grade.value)
        })
        return item.text
      },
      toggleExpandCollapse (index) {
        setTimeout(() => {
          if ($('#institution-' + index).hasClass('show')) {
            $('#inst-head-exp-coll-' + index).text('-')
          } else {
            $('#inst-head-exp-coll-' + index).text('+')
          }
        }, 500)
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        let splitted = course.title.split('-')
        if (splitted.length > 0) {
          return splitted[0]
        }
        return course.sourceCatalogId
      },
      async populateTermsGradesAndCategories () {
        let termsGradesAndCaregories = await this.loadTermsGradesAndCategoriesFromInstitution()
        if (termsGradesAndCaregories.terms && termsGradesAndCaregories.terms.length > 0) {
          this.terms = termsGradesAndCaregories.terms
        }
        if (termsGradesAndCaregories.grades && termsGradesAndCaregories.grades.length > 0) {
          this.grades = termsGradesAndCaregories.grades
        }
        if (termsGradesAndCaregories.categories && termsGradesAndCaregories.categories.length > 0) {
          this.categories = termsGradesAndCaregories.categories
        }
      },
      async loadCourseList (keyword) {
        this.countInfo = await this.loadSelfReportedProgramCountInfo()
        this.loadSelfReportedCourseList(keyword).then(result => {
          this.selfReportedCourseMap = _.groupBy(result, 'sourceInstitutionTitle')
          this.totalElements = result.length
          this.hideLoader()
          this.selected = [],
          this.isCoursesLoaded = true
        })
      },
      addCourse () {
        Object.assign(this.$data.addCourseModel, initAddCourseModel())
        this.$v.addCourseModel.$reset()
        this.addCourseModel.sourceInstitutions = this.partnerInstitutions
        this.$refs.addCourseModal.show()
      },
      addCourseFromWidget () {
        if (this.$parent.isGuestLogin) {
          localStore.setItem('AddCourseClicked', 'yes')
          window.parent.postMessage({name: 'Login'}, '*')
        } else {
          Object.assign(this.$data.addCourseModel, initAddCourseModel())
          this.$v.addCourseModel.$reset()
          this.addCourseModel.sourceInstitutions = this.partnerInstitutions
          this.$parent.showAddCoursePopover = true
        }
      },
      closeAddCourseFromWidget () {
        this.$parent.showAddCoursePopover = false
        Object.assign(this.$data.addCourseModel, initAddCourseModel())
      },
      loginToAdd () {
        window.parent.postMessage({name: 'Login'}, '*')
      },
      async editCourse (uuid) {
        this.addCourseModel.addEditCourseButton = 'update course'
        this.addCourseModel.addEditCourseHeader = 'Add Completed Course to Save Time and Money'
        let resp = await this.loadSelfReportedCourse(uuid)
        if (resp) {
          this.addCourseModel.uuid = resp.uuid
          this.addCourseModel.sourceInstitution = _.find(this.partnerInstitutions, (inst) => {
            return (resp.sourceInstitutionOpenId === inst.openId)
          })
          await this.populateCataloags(resp.sourceInstitutionOpenId)
          this.addCourseModel.sourceCatalog = _.find(this.addCourseModel.sourceCatalogs, (catalog) => {
            return (resp.sourceCatalogId === catalog.catalogId)
          })
          this.addCourseModel.sourceCategory = resp.sourceCategory
          this.addCourseModel.grade = resp.gradeEarned
          this.addCourseModel.year = resp.year
          this.addCourseModel.term = resp.term
          if (this.isLoadingOnWidget) {
            this.$parent.showAddCoursePopover = true
          } else {
            this.$refs.addCourseModal.show()
          }
        }
      },
      selectForDelete (uuid) {
        this.selected = []
        this.selected.push(uuid)
        this.showDeleteConfirm()
      },
      showDeleteConfirm () {
        if (this.selected.length > 0) {
          this.$refs.deleteConfirmModal.show()
        }
      },
      deleteSelected () {
        this.$refs.deleteConfirmModal.hide()
        this.showLoader()
        this.deleteSelfReportedCourses(this.selected).then(res => {
          if (res) {
            if (res.succeeded > 0) {
              let message = '' + res.succeeded + ' Course deleted successfully.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: message
                })
              }, 0)
            }
            if (res.unauthorized > 0) {
              let message = '' + res.unauthorized + ' Course(s) not deleted due to lack of permission.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'warn',
                  title: '',
                  text: message
                })
              }, 500)
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Course deletion failed due to network issue.'
            })
          }
          setTimeout(() => {
            this.loadCourseList()
          }, 1000)
        })
        this.selected = []
      },
      cancelDelete () {
        this.$refs.deleteConfirmModal.hide()
        this.selected = []
      },
      keyupEvent (event) {
        this.page = 0
        this.loadCourseList(this.searchTitle)
      },
      resetPage () {
        this.page = 0
        this.searchTitle = ''
        this.loadCourseList()
      },
      backToExplore () {
        return this.$router.push({name: 'exploreProgramGuideResults'})
      },
      forceUpperCase (e, prop) {
        e = e.trim().toUpperCase()
        this.$set(this.$data.addCourseModel, prop, e)
      },
      async populateCataloags (openId) {
        this.addCourseModel.sourceCatalogs = await this.loadCatalogsForInstitution(openId)
      },
      cancel () {
        this.$refs.addCourseModal.hide()
        Object.assign(this.$data.addCourseModel, initAddCourseModel())
      },
      async save () {
        this.$v.$touch()
        if (this.$v.$invalid) {
          let text = '<b><sup>*</sup></b> fields are required'
          this.showNotification(text, 'error')
          return
        }
        this.showLoader()
        let data = {
          userId: this.userId,
          sourceCategory: this.addCourseModel.sourceCategory,
          title: this.addCourseModel.sourceCatalog.title,
          sourceCatalogId: this.addCourseModel.sourceCatalog.catalogId,
          sourceInstitutionId: this.addCourseModel.sourceInstitution.uuid,
          sourceInstitutionTitle: this.addCourseModel.sourceInstitution.title,
          sourceInstitutionOpenId: this.addCourseModel.sourceInstitution.openId,
          gradeEarned: this.addCourseModel.grade.value,
          year: this.addCourseModel.year,
          term: this.addCourseModel.term
        }
        if (this.addCourseModel.uuid) {
          data.uuid = this.addCourseModel.uuid
        }
        let response = await this.loadAddSelfReportedCourse(data)
        let status = response.status
        if (status === 200) {
          if (this.isLoadingOnWidget) {
            this.closeAddCourseFromWidget()
          } else {
            this.$refs.addCourseModal.hide()
          }
          let text = '<b>' + data.title + '</b> successfully added.'
          if (data.uuid) {
            text = '<b>' + data.title + '</b> successfully updated.'
          }
          this.showNotification(text, 'success')
          setTimeout(() => {
            this.resetPage()
          }, 500)
        } else if (status === 409) {
          let text = '<b>' + data.title + '</b> form <b>' + data.sourceInstitutionTitle + '</b> is already added. Try to add any other course.'
          this.showNotification(text, 'warn')
        }
      },
      showNotification (text, type) {
        this.$notify({
          group: 'notify',
          type: type,
          title: '',
          text: text
        })
      }
    },
    computed: {
      ...mapState({
        'partnerInstitutions': state => state.institution.partnerInstitutions
      }),
      years () {
        const now = new Date().getUTCFullYear()
        return Array(now - (now - 10)).fill('').map((v, idx) => now - idx)
      }
    },
    watch: {
      'addCourseModel.sourceInstitution' (newValue) {
        if (newValue) {
          const openId = newValue.openId
          this.populateCataloags(openId)
          this.addCourseModel.sourceCatalog = ''
        }
      }
    }
  }
</script>

<style>
  .user-profile {
    width: 28px;
    height: 28px;
    float: left;
    font-size: 28px;
    color: #fff;
    margin: 0px 5px 0 0;
  }
  .user-profile-icon {
    height: 28px;
    width: 28px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    font-size: 19px;
    background-color: #960580;
  }
  .bg-light-gray {
    background-color: #f5f5f5 !important;
  }
  .institution-head {
    width: 25%;
    margin-bottom: 12px;
    min-width: 325px;
  }
  .institution-head-title {
    padding: 15px 0px 15px 20px;
    font-size: 18px;
    font-weight: 800;
  }
  .institution-head-title-circle {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    display: inline-block;
    border: 3px solid #9fd5ed;
    line-height: 16px;
    text-align: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    color: #9fd5ed;
  }
  .popup_head_txt {
    font-size: 1.1rem;
    float: left;
    color: #323232;
  }
  .bg-delete-course-popup-header {
    background: #c0c0c0 !important;
  }
  sup {
    color: #ff0000;
  }
</style>



// WEBPACK FOOTER //
// src/app/transfer/components/SelfReportedCourseList.vue